// debug buttons to test audio, text prompt and teleport WS command
import { keys } from '@core/assistant/voiceCommand';
import { enableLogging, assistantSize } from '@core/assistant/constants';
import { MytaverseLogger } from '@helpers/logger';
import AssistantQueryService from '@services/AssistantQueryService';
import { visualizeAudio } from './AudioVisualizer';

import { socket } from './Socket';
import { IDebug } from './interfaces';
import { SocketEventRequestType, SocketEventDirection } from './interfacesOld';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _sendJSONMessageToWebSocket: (msg: any) => void = () => {};

// Called by AssistantProviderInner to wire up the WS sender without a context subscription
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initDebugSendFn = (fn: (msg: any) => void) => {
  _sendJSONMessageToWebSocket = fn;
};

export const useDebug = (): IDebug => {
  const queryBedrockTest = () => {
    log('queryBedrockTest clicked');
    socket.emit(SocketEventDirection.request, {
      type: SocketEventRequestType.bedrock,
      data: { text: 'What is AWS?' },
    });
  };

  const generateAudioPlaybackTest = async () => {
    log('generateAudioPlaybackTest clicked');

    let arrayBuffer: ArrayBuffer | null = null;

    try {
      arrayBuffer = await AssistantQueryService.generateAssistantAudio({
        text: 'This is a test',
        disableOptimizations: true,
      });
    } catch (e) {
      log('Error: failed to fetch Polly audio', e);
      return;
    }

    if (!arrayBuffer || arrayBuffer.byteLength === 0) {
      log('Error: empty or missing Polly audio response');
      return;
    }

    console.log(
      `Polly audio size before playback: ${(
        arrayBuffer.byteLength / 1024
      ).toFixed(2)} KB`,
    );

    let visualizerInstance: any;

    if (visualizerInstance) {
      visualizerInstance.stopAudio();
    }
    visualizerInstance = visualizeAudio(
      assistantSize.width,
      assistantSize.height,
      () => {},
    );
    visualizerInstance = visualizerInstance.initialize(arrayBuffer);
  };

  // simulate N key in GameCast
  function testKeyboard() {
    new KeyboardEvent('keydown', keys.t);
    // TODO
    /*gameCastRef.current.detachInput();
    gameCastRef.current.attachInput();
    gameCastRef.current.processKeyboardEvent(enterEvent);*/
  }

  function sendWSMessage(message: string) {
    log('sendWSMessage', message);

    const wsMessage = JSON.parse(message);

    log('sendJSONMessageToWebSocket', wsMessage);

    _sendJSONMessageToWebSocket(wsMessage);
  }

  return {
    queryBedrockTest,
    generateAudioPlaybackTest,
    testKeyboard,
    sendWSMessage,
  };
};

export const log = (message: string, payload?: any) => {
  if (enableLogging) {
    MytaverseLogger.debug(message, payload);
  }
};
